module.exports = __webpack_public_path__ + "first.c2899408.png";